import MenuService from '@/service/menu'

export default {
  getMenu ({commit}, payload) {
    return new Promise((resolve, reject) => {
      MenuService.getMenu().then(res => {
        resolve(res.data.data)
        commit('getMenu', res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  getMenus ({commit}, payload) {
    return new Promise((resolve, reject) => {
      MenuService.getMenu().then(res => {
        resolve(res.data.data)
        // commit('getMenu', res.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  getMenuOfGroup ({commit}, payload) {
    return new Promise((resolve, reject) => {
      MenuService.getMenuOfGroup(payload.group_id).then(res => {
        resolve(res.data.data)
        // commit('getMenu', res.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  updateMenu ({commit}, payload) {
    // var CircularJSON = require('circular-json')
    return new Promise((resolve, reject) => {
      MenuService.updateMenu(payload.data, payload.group).then(res => {
        resolve(res.data)
        // commit('getMenu', res.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/module/menu/actions.js